import { REVIEW_STATUS, buildManualReviewResult } from '../utils/verificationStatus';

const host = () => process.env.REACT_APP_HOST_SERVER;

function authHeaders(token) {
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function parseJson(response) {
  return response.json().catch(() => ({}));
}

/**
 * Queue a secure-mode verification for admin review instead of sending notifications immediately.
 */
export async function submitForManualReview(checkId, token) {
  if (!checkId) {
    throw new Error('Missing verification check id.');
  }

  let response = await fetch(`${host()}/api/nominee-verifications/${checkId}/submit-for-review`, {
    method: 'POST',
    headers: authHeaders(token),
  });

  if (response.status === 404) {
    response = await fetch(`${host()}/api/nominee-verifications/${checkId}`, {
      method: 'PATCH',
      headers: authHeaders(token),
      body: JSON.stringify({ reviewStatus: REVIEW_STATUS.PENDING_REVIEW }),
    });
  }

  const json = await parseJson(response);
  if (!response.ok || json.successful === false) {
    throw new Error(json.message || 'Unable to submit this check for manual review.');
  }

  return buildManualReviewResult(json.message);
}

/** Admin approves — backend should send approval email with relevant document details. */
export async function approveVerificationReview(checkId, token) {
  const response = await fetch(`${host()}/api/admin/verifications/${checkId}/approve`, {
    method: 'POST',
    headers: authHeaders(token),
  });
  const json = await parseJson(response);
  if (response.status === 403) {
    throw new Error('You do not have admin access.');
  }
  if (!response.ok || json.successful === false) {
    throw new Error(json.message || 'Unable to approve this verification.');
  }
  return json;
}

/** Admin rejects — backend should send rejection email to the requester. */
export async function rejectVerificationReview(checkId, token, reason = '') {
  const response = await fetch(`${host()}/api/admin/verifications/${checkId}/reject`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify({ reason: reason.trim() || undefined }),
  });
  const json = await parseJson(response);
  if (response.status === 403) {
    throw new Error('You do not have admin access.');
  }
  if (!response.ok || json.successful === false) {
    throw new Error(json.message || 'Unable to reject this verification.');
  }
  return json;
}
